import { __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { Text } from '../../new-libby/core/typography';
export var HeatmapKey = 'heatmap';
var MAX_DATA = 14;
var WIDTH_SCALE = 0.93;
var HEIGHT_SCALE = 0.7;
export var heatmapColors = ['#fef5f2', '#fedbd0', '#fec1ae', '#fea589', '#fe8057'];
var Heatmap = /** @class */ (function (_super) {
    __extends(Heatmap, _super);
    function Heatmap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            width: 0,
            height: 0,
            scrollLength: 0,
            showRightIcon: false,
        };
        _this.heatmapRef = React.createRef();
        _this.handleScroll = function (event) {
            _this.setState({ scrollLength: event.target.scrollLeft });
        };
        _this.getColor = function (val) {
            var props = _this.props;
            var range = Math.round((props.maxVal - props.minVal) / 5);
            var idx = props.maxVal < 5 ? (val - 1) : Math.floor((val - 1 - props.minVal) / range);
            if (val === 0) {
                return '#ffffff';
            }
            if (idx === 5 || idx > 5) {
                return heatmapColors[4];
            }
            if (idx < 0) {
                return heatmapColors[0];
            }
            return heatmapColors[idx];
        };
        _this.getCol = function (colIdx) {
            var _a = _this, props = _a.props, state = _a.state;
            var size = props.data[0].length;
            var itemHeight = (state.height) / size;
            return __spreadArrays(props.data[colIdx]).map(function (rowVal, rowIdx) {
                var tooltipBody = props.getTooltipBody(colIdx, rowIdx);
                var color = _this.getColor(rowVal);
                var marginLeft = colIdx === 0 ? 1 : -1;
                var paddingBottom = ((rowIdx + 1) % size === 0) ? 2 : 0;
                return (React.createElement(Tooltip, { key: rowVal + "-" + rowIdx + "-" + color, body: tooltipBody, relativeToBody: true },
                    React.createElement("div", { className: 'cell-container', style: { height: itemHeight, paddingBottom: paddingBottom, marginLeft: marginLeft } },
                        React.createElement("div", { className: 'mat-item', style: { backgroundColor: color, height: '100%' }, key: "" + colIdx + rowVal }))));
            });
        };
        _this.renderMatrix = function () {
            var props = _this.props;
            return props.data.map(function (_, xInd) {
                var xAxis = (React.createElement("div", { className: 'xAxis-container' },
                    React.createElement(Text, { type: 'ts', color: 't40' }, props.renderXlabel(xInd))));
                var width = _this.state.width / props.data.length - 10;
                return (React.createElement("div", { style: { width: width }, key: xInd, className: 'col-container' },
                    _this.getCol(xInd),
                    xAxis));
            });
        };
        _this.getColorRange = function (ind) {
            var _a = _this.props, minVal = _a.minVal, maxVal = _a.maxVal;
            var text;
            if (_this.props.ranges) {
                text = React.createElement(Text, { type: 'ts', color: 't40' }, _this.props.ranges[ind]);
            }
            else if (maxVal < 5) {
                text = React.createElement(Text, { type: 'ts', color: 't40' },
                    ind + 1,
                    ind === maxVal ? '+' : '');
            }
            else {
                var range = Math.round((maxVal - minVal) / 5);
                text =
                    ind === 0 ?
                        React.createElement(Text, { type: 'ts', color: 't40' },
                            minVal + (range * ind),
                            "-",
                            minVal + (range * (ind + 1)))
                        :
                            (ind === 4 ?
                                React.createElement(Text, { type: 'ts', color: 't40' },
                                    minVal + (range * ind) + 1,
                                    "+")
                                :
                                    React.createElement(Text, { type: 'ts', color: 't40' },
                                        minVal + (range * ind) + 1,
                                        "-",
                                        minVal + (range * (ind + 1))));
            }
            return (React.createElement("div", { className: 'color-text-container' },
                React.createElement("div", { className: 'color-square', style: { background: heatmapColors[ind] } }),
                text));
        };
        _this.renderColorsMenu = function () {
            return (React.createElement("div", { className: 'colors-menu-container' }, new Array(Math.min(_this.props.maxVal, 5)).fill(0).map(function (_, ind) { return _this.getColorRange(ind); })));
        };
        _this.renderYAxis = function (xIdx) {
            var _a = _this, props = _a.props, state = _a.state;
            var yAxisSize = props.data[0].length;
            var itemHeight = (state.height) / yAxisSize;
            var style = { height: itemHeight };
            if (xIdx === 0) {
                return new Array(yAxisSize).fill(0).map(function (_, yInd) {
                    return (React.createElement("div", { key: "" + yInd, style: style, className: 'yAxis-item' },
                        React.createElement(Text, { type: 'ts', color: 't40' }, _this.props.renderYlabel(yInd))));
                });
            }
            return null;
        };
        return _this;
    }
    Heatmap.prototype.componentDidMount = function () {
        if (this.props.data.length > MAX_DATA) {
            this.setState({ showRightIcon: true });
        }
        var element = this.heatmapRef.current;
        if (element) {
            element.addEventListener('scroll', this.handleScroll);
            this.setState({
                width: Math.floor(element.offsetWidth * WIDTH_SCALE),
                height: Math.floor(element.offsetHeight * HEIGHT_SCALE)
            });
        }
    };
    Heatmap.prototype.componentDidUpdate = function () {
        var element = this.heatmapRef.current;
        if (element
            && element.offsetHeight !== this.state.height
            && element.offsetWidth !== this.state.width) {
            this.setState({
                width: Math.floor(element.offsetWidth * WIDTH_SCALE),
                height: Math.floor(element.offsetHeight * HEIGHT_SCALE)
            });
        }
    };
    Heatmap.prototype.render = function () {
        var state = this.state;
        var className = state.scrollLength > 10 ? 'yAxis-container scroll' : 'yAxis-container';
        return (React.createElement("div", { className: namespacedClassnames(HeatmapKey), ref: this.heatmapRef },
            React.createElement("div", { className: 'range-colors-menue' }, this.renderColorsMenu()),
            React.createElement("div", { className: 'map-container' },
                React.createElement("div", { className: "" + className }, this.renderYAxis(0)),
                React.createElement("div", { className: 'matrix-container' }, this.renderMatrix()))));
    };
    return Heatmap;
}(React.PureComponent));
export { Heatmap };
//# sourceMappingURL=index.js.map